import { useMarketsCommon } from '@eih-netbroker/common';
import { useMemo } from 'react';
import { useLocale } from '../../context/NbLocalizationContext';
import { Config } from '../config/config';

export const useMarkets = () => {
  const { translation } = useLocale();

  const p = useMemo(() => ({ translation, marketsConfig: Config.NetBroker.Markets.markets }), [translation]);

  return useMarketsCommon(p);
};
